import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldThrResponse } from '@/api/routes/stat/types';

import { fetchAggrDeviceMileageFieldThr } from './actionCreators';

interface InitialState {
  aggrThrByMileageField: AggrDeviceFieldThrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrThrByMileageField: [],
  isLoading: false,
  error: '',
};

export const aggrDeviceByMileageFieldSlice = createSlice({
  name: 'aggrDeviceByMileageField',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAggrDeviceMileageFieldThr.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldThrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.aggrThrByMileageField = action.payload;
    },
    [fetchAggrDeviceMileageFieldThr.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrDeviceMileageFieldThr.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggrDeviceByMileageFieldSlice.reducer;
